import { Button, CircularProgress, Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RepLIProviderTextField } from '../../../components';
import RepLITextFieldSkeleton from '../../../components/RepLITextFieldSkeleton';

import useStyles from './MessageForm.style';

const MessageForm = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <form onSubmit={props.onSubmit}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={8}>
                    {props.loading ?
                        <RepLITextFieldSkeleton />
                        : <RepLIProviderTextField
                            label={`${t('common.form.label.title')}*`}
                            autoFocus
                            error={props.submitted && !props.validator.current.fieldValid('title')}
                            inputProps={{ maxLength: 120 }}
                            helperText={props.validator.current.message('title', props.title, 'required')}
                            onChange={props.onTitleChange}
                            value={props.title}
                        />
                    }
                </Grid>
                <Grid item xs={12} md={8}>
                    {props.loading ?
                        <RepLITextFieldSkeleton />
                        : <RepLIProviderTextField
                            label={`${t('common.form.label.body')}*`}
                            error={props.submitted && !props.validator.current.fieldValid('body')}
                            inputProps={{ maxLength: 250 }}
                            helperText={props.validator.current.message('body', props.body, 'required')}
                            onChange={props.onBodyChange}
                            value={props.body}
                            multiline
                            rows={4}
                        />
                    }
                </Grid>
                <Grid item xs={12} md={8}>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={props.sending}
                    >
                        {t('common.form.button.save')}
                        {props.sending && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default MessageForm;